import React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { BANNER_TAB, INTEGRATION_TAB, NOTIFICATIONS_TAB, ORDERS_TAB, PRODUCTS_TAB, PRODUCT_BASE_TAB, REQUESTS_TAB, SALES_TAB, STATISTIC_TAB, STOCK_TAB, USERS_TAB, PURCHASES_TAB, LOGS_TAB, SUPPLIER_PRODUCT_STATUSES_TAB, BUSINESS_CALENDAR_TAB, AUTOBASE_TAB, SITE_INFO_TAB } from "../constant";
import { ProductsIcon } from '../appearence/icons/products_icon';
import { RequestsIcon } from '../appearence/icons/requests_icon';
import { OrdersIcon } from '../appearence/icons/orders_icon';
import { PurchasesIcon } from '../appearence/icons/purchases_icon';
import { GearIcon } from '../appearence/icons/gear_icon';
import { StatisticIcon } from '../appearence/icons/statistic_icon';
import { StockIcon } from '../appearence/icons/stock_icon';
import { ConfigurationIcon } from '../appearence/icons/configuration_icon';
import { BannerIcon } from '../appearence/icons/banner_icon';
import { FoundationIcon } from '../appearence/icons/foundation_icon';
import { ButtonIcon } from '../appearence/icons/button_icon';

const LIST_OF_MENU_TABS = [
    {
        title: 'Продажи',
        tabName: SALES_TAB,
        icon: OrdersIcon,
        description: 'Заказы клиентов, состояние обеспечения заказов ',
        defaultPath: '/sales/orders',
    },
    {
        title: 'Закупки',
        tabName: PURCHASES_TAB,
        icon: PurchasesIcon,
        description: 'Документы закупки',
        defaultPath: '/purchases/supplier-orders',
    },
    {
        title: 'Продукты',
        tabName: PRODUCTS_TAB,
        icon: ProductsIcon,
        description: 'Расширенный поиск товаров, справочная информация',
    },
    {
        title: 'Запросы',
        tabName: REQUESTS_TAB,
        icon: RequestsIcon,
        description: 'Запросы пользователей и обработка',
    },
    {
        title: 'Интеграции',
        tabName: INTEGRATION_TAB,
        icon: GearIcon,
        description: 'Настройка и мониторинг интеграций',
    },
    {
        title: 'Статистика',
        tabName: STATISTIC_TAB,
        icon: StatisticIcon,
        description: 'Отчёты и показатели',
    },
    {
        title: 'Склады',
        tabName: STOCK_TAB,
        icon: StockIcon,
        description: 'Склады, остатки, обновления',
    },
    {
        title: 'Уведомления',
        tabName: NOTIFICATIONS_TAB,
        icon: ButtonIcon,
        description: 'Шаблоны и рассылки уведомлений',
    },
  {
      title: 'Календарь',
      tabName: BUSINESS_CALENDAR_TAB,
      icon: ConfigurationIcon,
      description: 'Производственный календарь (RU / CN)',
      defaultPath: '/business-calendar',
  },
    {
        title: 'Логи',
        tabName: LOGS_TAB,
        icon: RequestsIcon,
        description: 'Просмотр логов',
        defaultPath: '/logs',
    },
    {
        title: 'Баннер',
        tabName: BANNER_TAB,
        icon: BannerIcon,
        description: 'Управление баннерами',
    },
    {
        title: 'Статусы поставщика',
        tabName: SUPPLIER_PRODUCT_STATUSES_TAB,
        icon: BannerIcon,
        description: 'Настройка статусов товара поставщика',
        defaultPath: '/supplier-statuses',
    },
    {
        title: 'Autobase',
        tabName: AUTOBASE_TAB,
        icon: ConfigurationIcon,
        description: 'Настройки автозагрузки: прокси и ключи API',
        defaultPath: '/autobase',
    },
    {
        title: 'Информация',
        tabName: SITE_INFO_TAB,
        icon: ConfigurationIcon,
        description: 'Документы и данные',
        defaultPath: '/site-info',
    },
    // {
    //     title: 'База продуктов',
    //     tabName: PRODUCT_BASE_TAB,
    //     icon: FoundationIcon,
    // },
];

const MainPage = ({isCollapsed, setIsCollapsed}) => {
    const location = useLocation();
    const navigate = useNavigate();

    const isSalesPath = location.pathname === `/${SALES_TAB}` || location.pathname.startsWith(`/${SALES_TAB}/`);

    const handleChangeTab = (tabName, defaultPath) => {
        navigate(defaultPath || '/'+tabName);
        setIsCollapsed(false);
    };

    return (
        <nav className={`page-menu ${isCollapsed ? 'page-menu_collapsed' : 'page-menu_full-width'}`}>
            <ul className={`menu__list ${isCollapsed ? 'menu__list_collapsed' : ''}`}>
                {LIST_OF_MENU_TABS.map(it => (
                    <a
                        key={it.title + it.tabName}
                        href={it.defaultPath || `/${it.tabName}`}
                        onClick={(e) => {
                            e.preventDefault();
                            handleChangeTab(it.tabName, it.defaultPath);
                        }}
                        className={`menu__item ${isCollapsed ? 'menu__item_collapsed' : 'menu__item_full-width'} navigation-link`}
                        style={it.hidden ? { display: 'none' } : undefined}
                    >
                        {it.icon({
                            nameOfClass: (location.pathname.includes(it.tabName) || (it.tabName === SALES_TAB && isSalesPath))
                                ? `menu__icon menu__icon_active ${location.pathname.includes(REQUESTS_TAB) ? 'menu__icon-requests_active' : ''}`
                                : `menu__icon ${it.tabName === REQUESTS_TAB ? 'menu__icon-requests' : ''}`,
                        })}
                        <h2
                            className={`menu__title ${(location.pathname.includes(it.tabName) || (it.tabName === SALES_TAB && isSalesPath)) ? 'menu__title_active' : ''}
                                ${isCollapsed ? 'menu__title_collapsed' : 'menu__title_full-width'}`}
                        >
                            {it.title}
                        </h2>
                        <p className={`menu__text ${isCollapsed ? 'menu__text_collapsed' : 'menu__text_full-width'}`}>
                            {it.description}
                        </p>
                    </a>
                ))}
            </ul>
        </nav>
    );
};

export default MainPage;
